<nz-layout>
    <nz-content class="table-container">
        <div class="table-wrapper" (scroll)="onScroll($event)" (scrollend)="onScrollEnd($event)" #scroll>
            <table-pro [config]="config!" [currentPage]="pager.pageIndex" [currentPageSize]="pager.pageSize"
                [tableData]="recordList" (queryPanelStateChange)="queryPanelStateChange($event)"
                (resetClick)="resetSearch()" (searchClick)="searchClick($event)" [stickyTop]="40"
                (afterEdit)="afterEdit($event)">

                <div class="grid overview" overview>
                    <div class="row">
                        <div class="column no-border" [style.width]="'150px'">
                            <nz-cascader class="color-primary" (ngModelChange)="onSectionChange()"
                                [nzOptions]="cascaderOptions" [(ngModel)]="cascaderValue" [nzShowSearch]="true"
                                [nzPlaceHolder]="'选择标段'" [nzAllowClear]="false">
                            </nz-cascader>
                        </div>
                        <div class="column no-border" [style.width]="'10rem'">
                            <b>桥梁荷载试验</b>
                        </div>
                        <div class="column no-border" [style.width]="'10rem'">
                            桥梁荷载试验报告：
                        </div>
                        <div class="column no-border clickable color-primary" [style.width]="'8rem'"
                            *ngFor="let report of reportList" (click)="view(report.id!)">
                            {{report.fileSn}}
                        </div>
                        <div class="column no-border" [style.width]="'4rem'">
                            <button nz-button nzType="primary" (click)="addReport()" [disabled]="!canWrite">+报告
                            </button>
                        </div>
                    </div>
                </div>

            </table-pro>
        </div>
    </nz-content>

    <nz-footer class="footer">
        <nz-pagination [nzPageIndex]="pager.pageIndex" [(nzPageSize)]="pager.pageSize"
            [nzPageSizeOptions]="pager.pageSizeOptions" [nzTotal]="pager.total" nzShowQuickJumper
            [nzShowSizeChanger]="true" [nzShowQuickJumper]="true" (nzPageIndexChange)="pageIndexChange($event)"
            (nzPageSizeChange)="pageSizeChange($event)">
        </nz-pagination>
    </nz-footer>
</nz-layout>